import { GraphQLField } from 'graphql';
import DateField from '@/components/FormBuilder/fields/DateField.vue';
import FieldComponentFactory from './FieldComponentFactory';

export default class TextFieldFactory extends FieldComponentFactory {
  readonly component = DateField;

  support(field: GraphQLField<any, any, any>): boolean {
    const { type } = field;

    // Пимкор никак не отмечает даты на уровне типа -- прилетает всего лишь строка.
    // Приходится полагаться на кодировку типа в имени поля.
    return this.typeInspector.isScalarType(type)
    && this.typeInspector.isString(type)
    && field.name.includes('date');
  }
}
